import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataImage = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 3.375a2.25 2.25 0 00-2.25-2.25H2.25A2.25 2.25 0 000 3.375v10.5a2.25 2.25 0 002.25 2.25h13.5a2.25 2.25 0 002.25-2.25v-10.5zm-2.25-.75a.75.75 0 01.75.75v4.19l-1.94-1.94a1.5 1.5 0 00-2.12 0l-4.19 4.19-1.19-1.19a1.5 1.5 0 00-2.12 0l-3.44 3.44v-8.69a.75.75 0 01.75-.75h13.5zM1.547 14.138L6 9.685l2.25 2.25 5.25-5.25 3 3v4.19a.75.75 0 01-.75.75H2.25a.751.751 0 01-.703-.487zM6 5.625a1.5 1.5 0 10-3.001.001A1.5 1.5 0 006 5.625z",
		fillRule: "evenodd"
	})
});
export default SvgDataImage;
